module.exports = __webpack_public_path__ + "img/12-EXOSPresent.0588f9ea.jpg";